/**
 * 1. Calculate the future value of current savings (FVCS) = P(1 + r/n)nt
 *
 * 2. Calculate required increase = Goal – FVCS
 *
 * 3. Calculate monthly payment needed to
 * generate required increase:
 *
 *  M = Goal(r/n) / [(1 + r/n)^nt - 1]
 *
 * @returns {number}
 */
const requiredPaymentToGoal = (goal, interestRate, time, principle = 0, n = 12) => {
  const timeToGoal = time * n
  const interest = interestRate / n
  const compounded = Math.pow(1 + interest, timeToGoal)
  const futureValueOfCurrentSavings = principle * compounded

  const result = ((goal - futureValueOfCurrentSavings) * interest) / (compounded - 1)

  return result >= 0 ? result : null
}

export default requiredPaymentToGoal



// WEBPACK FOOTER //
// ./src/utils/calculations/requiredPaymentToGoal.js